/* GlobifySIM – WhatsApp-Links auf dem Handy direkt in der App öffnen */
(function () {
  "use strict";

  function istHandy() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || "");
  }

  document.addEventListener("click", function (e) {
    var a = e.target.closest ? e.target.closest("[data-gs-wa]") : null;
    if (!a) return;
    var nummer = a.getAttribute("data-gs-wa");
    if (!nummer) return;
    var text = a.getAttribute("data-gs-wa-text") || "";
    if (!istHandy()) return; /* am Rechner bleibt der normale wa.me-Link */

    e.preventDefault();
    var app = "whatsapp://send?phone=" + nummer + (text ? "&text=" + encodeURIComponent(text) : "");
    var netz = a.getAttribute("href");
    var gewechselt = false;

    function merken() { gewechselt = true; }
    document.addEventListener("visibilitychange", merken, { once: true });

    window.location.href = app;
    window.setTimeout(function () {
      document.removeEventListener("visibilitychange", merken);
      if (!gewechselt && !document.hidden && netz) window.location.href = netz;
    }, 1500);
  });
})();
